import { call, put } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import {
  fetchInventoryLocationOptions as fetchInventoryLocationOptionsRoutine,
  fetchInventoryLocationZoneOptions as fetchInventoryLocationZoneOptionsRoutine,
  fetchInventoryDonorOptions as fetchInventoryDonorOptionsRoutine,
  adjustInventoryItem as adjustInventoryItemRoutine,
  adjustInventoryPackage as adjustInventoryPackageRoutine
} from './routines';
import {
  clearInventoryItemsAvailability,
  clearInventoryPackagesAvailability,
  clearInventoryAuditLogs
} from '../../../actions';

export const fetchInventoryLocationOptions = () =>
  sagaRoutineRequest(fetchInventoryLocationOptionsRoutine, {
    request: () => call(Api.fetchInventoryLocationOptions)
  });

export const fetchInventoryLocationZoneOptions = () =>
  sagaRoutineRequest(fetchInventoryLocationZoneOptionsRoutine, {
    request: () => call(Api.fetchInventoryLocationZoneOptions)
  });

export const fetchInventoryDonorOptions = () =>
  sagaRoutineRequest(fetchInventoryDonorOptionsRoutine, {
    request: () => call(Api.fetchInventoryDonorOptions)
  });

export const adjustInventoryItem = ({ payload: { id, body } }) =>
  sagaRoutineRequest(adjustInventoryItemRoutine, {
    request: () => call(Api.adjustInventoryItem, { id, body }),
    *success() {
      yield put(clearInventoryItemsAvailability());
      yield put(clearInventoryPackagesAvailability());
      yield put(clearInventoryAuditLogs());
      yield toastr.success('Success', `Changes saved.`);
    }
  });

export const adjustInventoryPackage = ({ payload: { id, body } }) =>
  sagaRoutineRequest(adjustInventoryPackageRoutine, {
    request: () => call(Api.adjustInventoryPackage, { id, body }),
    *success() {
      yield put(clearInventoryItemsAvailability());
      yield put(clearInventoryPackagesAvailability());
      yield put(clearInventoryAuditLogs());
      yield toastr.success('Success', `Changes saved.`);
    }
  });
